import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { f as i } from "./index-LyFokDcn.mjs";
import { m as u } from "./tss-DN0acMKN.mjs";
import { M as f, d as l } from "./constants-CnFYFetN.mjs";
import { P as x } from "./Paper-J9MVFbwr.mjs";
const R = u({ name: "RoundedBox" })(
  ({ palette: o, mode: e }, { backgroundColor: r, border: a, borderRadius: n, margin: t, padding: s }) => ({
    root: {
      backgroundColor: r || o.gray[100],
      border: a || "none",
      borderRadius: i.ifFeature("encore", 16, n || 8),
      margin: t,
      outline: e === f.Dye ? `1px solid ${l.main}` : void 0,
      padding: i.ifFeature("encore", "20px", s)
    }
  })
), k = ({
  backgroundColor: o,
  border: e,
  borderRadius: r,
  children: a,
  className: n,
  margin: t,
  padding: s,
  ...d
}) => {
  const { classes: m, cx: p } = R({
    backgroundColor: o,
    border: e,
    borderRadius: r,
    margin: t,
    padding: s
  });
  return /* @__PURE__ */ c.jsx(
    x,
    {
      className: p(m.root, n),
      elevation: 0,
      ...d,
      "data-fabric-component": [d["data-fabric-component"], "RoundedBox"].filter(Boolean).join(" "),
      children: a
    }
  );
};
export {
  k as R
};
//# sourceMappingURL=rounded-box-CXWaE0gJ.mjs.map
